import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { cookiePrefix } from '@fb-tool-front/shared/constants/shared.constant';
import { ErrorPageMessage } from '@fb-tool-front/shared/interfaces/shared.type';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  public isNightTheme$$: BehaviorSubject<boolean>;
  public isNightTheme$: Observable<boolean>;

  public errorPageMessage$$ = new BehaviorSubject<ErrorPageMessage>(null);
  public errorPageMessage$ = this.errorPageMessage$$.asObservable();

  constructor(
    private router: Router,
    private authService: AuthService,
    private cookieService: CookieService
  ) {
    const isNightThemeCookie = this.cookieService.get(`${cookiePrefix}is-night-theme`);

    this.authService.redirectToVendor$.subscribe(_ => this.errorPageMessage$$.next(null));

    this.isNightTheme$$ = new BehaviorSubject<boolean>(isNightThemeCookie === 'true');
    this.isNightTheme$ = this.isNightTheme$$.asObservable();
  }

  private navigateToPage(message: ErrorPageMessage, page: 'error' | 'start') {
    if (this.errorPageMessage$$.getValue()) {
      return;
    }
    this.errorPageMessage$$.next(message);
    this.router.navigate([page], { replaceUrl: true });
  }

  navigateToError(message: ErrorPageMessage) {
    this.navigateToPage(message, 'error');
  }

  navigateToStart(message: ErrorPageMessage) {
    this.navigateToPage(message, 'start');
  }
}
